// Mock data for Channel Module
export const mockChannels = [
  {
    id: "ch-1",
    name: "Customer Support WhatsApp",
    type: "whatsapp",
    agent_name: "Alex Support Agent",
    model_provider: "openai",
    description: "Main customer support channel for handling inquiries",
    status: "active",
    created_at: "2024-01-15T08:30:00Z",
    total_conversations: 1247,
    escalated_conversations: 23,
    config: {
      business_name: "PT. Digital Solutions",
      welcome_message:
        "Hello! Welcome to our customer support. How can we help you today?",
      business_hours: "08:00-22:00 WIB",
      features: ["text", "media", "audio", "document"],
    },
    stats: {
      daily_messages: 156,
      weekly_messages: 892,
      monthly_messages: 3421,
      resolved_conversations: 1198,
      avg_response_time: "47s",
      satisfaction_rate: 94.2,
      peak_hours: "14:00-16:00",
      most_common_query: "Product Information",
      response_accuracy: 89.5,
      escalation_rate: 1.8,
      daily_stats: [
        { date: "2024-01-20", messages: 45, conversations: 23, escalated: 1 },
        { date: "2024-01-21", messages: 67, conversations: 31, escalated: 2 },
        { date: "2024-01-22", messages: 89, conversations: 42, escalated: 0 },
        { date: "2024-01-23", messages: 123, conversations: 67, escalated: 3 },
        { date: "2024-01-24", messages: 156, conversations: 78, escalated: 1 },
        { date: "2024-01-25", messages: 134, conversations: 65, escalated: 2 },
        { date: "2024-01-26", messages: 98, conversations: 48, escalated: 1 },
      ],
    },
    media: [
      {
        id: "media-1",
        type: "image",
        filename: "product_catalog.jpg",
        size: "2.4 MB",
        uploaded_at: "2024-01-26T10:15:00Z",
        sender: "+6281234567890",
        url: "https://picsum.photos/300/200?random=1",
      },
      {
        id: "media-2",
        type: "document",
        filename: "invoice_2024_001.pdf",
        size: "156 KB",
        uploaded_at: "2024-01-26T09:30:00Z",
        sender: "+6281234567891",
        url: "#",
      },
      {
        id: "media-3",
        type: "image",
        filename: "screenshot_issue.png",
        size: "892 KB",
        uploaded_at: "2024-01-25T16:45:00Z",
        sender: "+6281234567892",
        url: "https://picsum.photos/300/200?random=2",
      },
      {
        id: "media-4",
        type: "audio",
        filename: "voice_message.mp3",
        size: "1.2 MB",
        uploaded_at: "2024-01-25T14:20:00Z",
        sender: "+6281234567893",
        url: "#",
      },
      {
        id: "media-5",
        type: "video",
        filename: "product_demo.mp4",
        size: "15.7 MB",
        uploaded_at: "2024-01-24T11:10:00Z",
        sender: "+6281234567894",
        url: "#",
      },
    ],
  },
  {
    id: "ch-2",
    name: "Sales WhatsApp Bot",
    type: "whatsapp",
    agent_name: "Sarah Sales Assistant",
    model_provider: "anthropic",
    description: "Automated sales inquiries and product recommendations",
    status: "active",
    created_at: "2024-01-10T10:15:00Z",
    total_conversations: 892,
    escalated_conversations: 12,
    config: {
      business_name: "Sales Department",
      welcome_message:
        "Hi! I'm here to help you find the perfect product. What are you looking for?",
      business_hours: "09:00-21:00 WIB",
      features: ["text", "media", "catalog"],
    },
    stats: {
      daily_messages: 89,
      weekly_messages: 567,
      monthly_messages: 2134,
      resolved_conversations: 865,
      avg_response_time: "23s",
      satisfaction_rate: 96.8,
      peak_hours: "10:00-12:00",
      most_common_query: "Pricing",
      response_accuracy: 92.1,
      escalation_rate: 1.3,
      daily_stats: [
        { date: "2024-01-20", messages: 32, conversations: 18, escalated: 0 },
        { date: "2024-01-21", messages: 54, conversations: 27, escalated: 1 },
        { date: "2024-01-22", messages: 76, conversations: 35, escalated: 0 },
        { date: "2024-01-23", messages: 89, conversations: 41, escalated: 1 },
        { date: "2024-01-24", messages: 67, conversations: 32, escalated: 0 },
        { date: "2024-01-25", messages: 78, conversations: 38, escalated: 1 },
        { date: "2024-01-26", messages: 89, conversations: 42, escalated: 0 },
      ],
    },
    media: [
      {
        id: "media-6",
        type: "image",
        filename: "product_brochure.jpg",
        size: "3.1 MB",
        uploaded_at: "2024-01-26T08:20:00Z",
        sender: "+6281234567895",
        url: "https://picsum.photos/300/200?random=3",
      },
      {
        id: "media-7",
        type: "document",
        filename: "price_list_2024.pdf",
        size: "234 KB",
        uploaded_at: "2024-01-25T13:15:00Z",
        sender: "+6281234567896",
        url: "#",
      },
    ],
  },
  {
    id: "ch-3",
    name: "Technical Support Telegram",
    type: "telegram",
    agent_name: "Mike Tech Helper",
    model_provider: "gemini",
    description: "Technical support and troubleshooting assistance",
    status: "pending",
    created_at: "2024-01-20T14:45:00Z",
    total_conversations: 234,
    escalated_conversations: 45,
    config: {
      business_name: "Tech Support",
      welcome_message:
        "Welcome to technical support! Please describe your issue.",
      business_hours: "24/7",
      features: ["text", "media", "file_sharing"],
    },
    stats: {
      daily_messages: 34,
      weekly_messages: 178,
      monthly_messages: 567,
      resolved_conversations: 189,
      avg_response_time: "1m 23s",
      satisfaction_rate: 87.4,
      peak_hours: "15:00-17:00",
      most_common_query: "Technical Issues",
      response_accuracy: 85.2,
      escalation_rate: 19.2,
      daily_stats: [
        { date: "2024-01-20", messages: 12, conversations: 8, escalated: 3 },
        { date: "2024-01-21", messages: 23, conversations: 15, escalated: 4 },
        { date: "2024-01-22", messages: 34, conversations: 19, escalated: 2 },
        { date: "2024-01-23", messages: 29, conversations: 16, escalated: 5 },
        { date: "2024-01-24", messages: 18, conversations: 12, escalated: 1 },
        { date: "2024-01-25", messages: 31, conversations: 17, escalated: 3 },
        { date: "2024-01-26", messages: 34, conversations: 18, escalated: 2 },
      ],
    },
    media: [
      {
        id: "media-8",
        type: "image",
        filename: "error_screenshot.png",
        size: "567 KB",
        uploaded_at: "2024-01-26T12:30:00Z",
        sender: "@username1",
        url: "https://picsum.photos/300/200?random=4",
      },
    ],
  },
  {
    id: "ch-4",
    name: "General Inquiry Web Widget",
    type: "web_widget",
    agent_name: "Emma Assistant",
    model_provider: "openai",
    description: "Website chat widget for general inquiries",
    status: "inactive",
    created_at: "2024-01-25T09:00:00Z",
    total_conversations: 67,
    escalated_conversations: 3,
    config: {
      business_name: "Website Support",
      welcome_message: "Hi! How can I help you today?",
      business_hours: "08:00-20:00 WIB",
      features: ["text", "quick_replies"],
    },
    stats: {
      daily_messages: 8,
      weekly_messages: 45,
      monthly_messages: 134,
      resolved_conversations: 64,
      avg_response_time: "12s",
      satisfaction_rate: 91.2,
      peak_hours: "11:00-13:00",
      most_common_query: "General Information",
      response_accuracy: 88.7,
      escalation_rate: 4.5,
      daily_stats: [
        { date: "2024-01-20", messages: 5, conversations: 3, escalated: 0 },
        { date: "2024-01-21", messages: 8, conversations: 5, escalated: 0 },
        { date: "2024-01-22", messages: 12, conversations: 7, escalated: 1 },
        { date: "2024-01-23", messages: 6, conversations: 4, escalated: 0 },
        { date: "2024-01-24", messages: 9, conversations: 6, escalated: 0 },
        { date: "2024-01-25", messages: 7, conversations: 4, escalated: 1 },
        { date: "2024-01-26", messages: 8, conversations: 5, escalated: 0 },
      ],
    },
    media: [],
  },
];

// Mock channel creation response
export const mockChannelCreateResponse = {
  message: "WhatsApp channel created successfully",
  channel: {
    id: 5,
    name: "WhatsApp Customer Service",
    type: "whatsapp",
    status: "pending",
  },
  authSetup: {
    type: "qr_scan",
    status: "ready",
    qrCode:
      "2@eHgorV2tWHQv9Km2ini1izxVyISoajv+uht/YFuSITcWsQ5+rBOPvaddQmoWxQC/PqFyXAGprwByCUx02/JRdFQ7vOp2NYbjGS0=",
    instructions: "Scan QR code with WhatsApp Business app to connect",
    channelId: 5,
    businessName: "TokoKita",
    message: "QR code ready! Scan with WhatsApp Business app to connect.",
  },
};

// Mock channel detail response
export const mockChannelDetail = {
  channel: {
    id: 1,
    name: "WhatsApp Business",
    type: "whatsapp",
    config: {
      business_name: "AI Customer Service Demo",
      welcome_message: "Halo! Ada yang bisa kami bantu?",
      features: ["text", "media", "audio"],
    },
    agent_id: 1,
    status: "active",
    created_at: "2025-09-04T09:14:39.392Z",
    updated_at: "2025-09-04T09:14:39.392Z",
    agent_name: "Customer Support Bot",
    model_provider: "groq",
    model_name: "llama-3.3-70b-versatile",
    total_conversations: 145,
    escalated_conversations: 12,
  },
  connection: {
    type: "whatsapp",
    status: "connected",
    isConnected: true,
    phoneNumber: "628123456789",
  },
  lastChecked: "2025-09-04T09:15:53.314Z",
};

// Helper functions
export const getStatusColor = (status) => {
  switch (status) {
    case "active":
      return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400";
    case "inactive":
      return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400";
    case "pending":
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400";
  }
};

export const getProviderColor = (provider) => {
  const colors = {
    groq: "bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-700",
    openai:
      "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 border-green-200 dark:border-green-700",
    anthropic:
      "bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-400 border-orange-200 dark:border-orange-700",
    google:
      "bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-400 border-purple-200 dark:border-purple-700",
  };
  return (
    colors[provider?.toLowerCase()] ||
    "bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400 border-gray-200 dark:border-gray-700"
  );
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("id-ID", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
